export default "__VITE_ASSET__D1RS_Gzb__"